export default __webpack_public_path__ + "static/media/headerBg.674f3320.png";